import { css } from '@emotion/css';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { ReactComponent as Arrow } from '../../assets/images/arrow_suggestion.svg';
import { Dialog } from '../shared/dialog/Dialog';
import { FriendBalloon } from '../shared/FriendBalloon';
import { reveal } from '../shared/keyframe-animations';
import { Photo } from '../shared/Photo';

export const BestFriendsHintDialog: React.FC = () => {
  const { t } = useTranslation(['best_friends', 'chat']);
  return (
    <Dialog hasHeader={true}>
      <div
        className={css`
          color: #938666;
          text-align: center;
          h1 {
            color: #4d3906;
            font-size: 20px;
            text-align: center;
          }
          section:last-child {
            padding-bottom: 40px;
          }
          .photo {
            width: 278px;
            height: 180px;
            margin: 32px auto;
            position: relative;
          }
          .balloon {
            position: absolute;
            top: 32px;
            right: -16px;
            transform: rotate(-2deg);
            filter: drop-shadow(0 0 12px rgba(0, 0, 0, 0.2));
          }
          .arrow {
            position: absolute;
            top: 56px;
            right: 19px;
            transform: rotate(2deg);
            @media (prefers-reduced-motion: no-preference) {
              svg {
                transform: translateY(-4px);
                animation: ${reveal} 0.4s ease-in-out infinite alternate;
              }
            }
          }
          .left-rotate {
            transform: rotate(-2deg);
          }
          .right-rotate {
            transform: rotate(2deg);
          }
          /* less than iPhone6/7/8 display size */
          @media screen and (max-width: 374px) {
            font-size: 14px;
            h1 {
              font-size: 18px;
            }
            .photo {
              width: 214px;
              height: 140px;
            }
            .arrow {
              top: 40px;
              right: 9px;
            }
          }
        `}
      >
        <h1>{t('help')}</h1>
        <section>
          <div className="photo left-rotate">
            <Photo
              srcSet={`
              /images/best-friends/img_bestfriends_tutorial_01-2x.jpg 2x,
              /images/best-friends/img_bestfriends_tutorial_01.jpg 1x
              `}
            />
          </div>
          <div>
            <p>{t('help_desc_01')}</p>
          </div>
        </section>
        <section>
          <div className="photo right-rotate">
            <Photo
              srcSet={`
              /images/best-friends/img_bestfriends_hint_01-2x.jpg 2x,
              /images/best-friends/img_bestfriends_hint_01.jpg 1x
              `}
            />
            <div className="balloon">
              <FriendBalloon text={t('chat:hint_balloon_text')} isDM={false} />
            </div>
          </div>
          <div
            className={css`
              p:nth-child(2) {
                margin: 32px 0 0;
              }
            `}
          >
            <p>{t('help_desc_02')}</p>
            <p>{t('help_desc_03')}</p>
          </div>
        </section>
        <section>
          <div className="photo photo3 left-rotate">
            <Photo
              srcSet={`
              /images/best-friends/img_bestfriends_hint_02-2x.jpg 2x,
              /images/best-friends/img_bestfriends_hint_02.jpg 1x
              `}
            />
            <div className="arrow">
              <Arrow />
            </div>
          </div>
          <div>
            <p>{t('help_desc_04')}</p>
          </div>
        </section>
      </div>
    </Dialog>
  );
};
